import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Tab, Tabs } from "react-bootstrap";
import Pagination from "react-js-pagination";
import { TableKyLai } from "./TableKyLai";
import { TraLai } from "./TraLai";
import { ThongTinHopDong } from "./ThongTinHopDong";
import NhanVayApi from "service/nhanVayApi";
import { convertToNumber } from "utils/numberExtension";
import { getDate } from "utils/formatDate";
import { currentDate } from "utils/formatDate";
import { getListNhanVay, updateDataSearch } from "../../../../actions/NhanVay/";
import { useSelector, useDispatch } from "react-redux";
import { pushNotification } from "utils/notifications";
import { formatDayMonth } from "utils/formatDate";
import { BtnInTraLai } from "./BtnInTraLai";

export const TraLaiNhanVay = (props) => {
  const dispatch = useDispatch();
  const dataSearch = useSelector((state) => state.dataSearchNhanVay);
  const searchInit = {
    nhanvayId: props.nhanvayId,
    pageIndex: 1,
    pageSize: 5,
  };
  const [dataSearchLanDongLai, UpdateDataSearchLanDongLai] =
    useState(searchInit);
  const dataInit = {
    List: [],
    TongTienLai: 0,
    TongTienGoc: 0,
    TongPhiKhac: 0,
    TongPhiKho: 0,
    TongCanThanhToan: 0,
    TongThanhToan: 0,
    TongBanGhi: 0,
    PaidMaxID: 0,
  };
  const [dataLanDongLai, UpdateDataLanDongLai] = useState(dataInit);

  const PhanTrang = (index) => {
    dataSearchLanDongLai.pageIndex = index;
    LoadLanThanhToan();
  };

  const LoadLanThanhToan = () => {
    NhanVayApi.lanThanhToan1(
      dataSearchLanDongLai.nhanvayId,
      dataSearchLanDongLai.pageIndex,
      dataSearchLanDongLai.pageSize
    ).then((response) => {
      UpdateDataLanDongLai({
        ...dataLanDongLai,
        List: response.data.List,
        TongTienLai: response.data.TongTienLai,
        TongTienGoc: response.data.TongTienGoc,
        TongPhiKhac: response.data.TongPhiKhac,
        TongPhiKho: response.data.TongPhiKho,
        TongCanThanhToan: response.data.TongCanThanhToan,
        TongThanhToan: response.data.TongThanhToan,
        TongBanGhi: response.data.TongBanGhi,
        PaidMaxID: response.data.PaidMaxID,
      });
    });
  };
  const [isShowFormDongLai, setShowFormDongLai] = useState(true);
  const showFormInMobile = () => {
    setShowFormDongLai(!isShowFormDongLai);
  };
  const UpdateThanhToan = (
    isThanhToan,
    NhanVayId,
    NgayThanhToan,
    NguoiNhan,
    TienThanhToan,
    PhiKhac,
    PhiKho,
    GhiChu,
    thuchiId
  ) => {
    if (isThanhToan === -1) {
      //Load lại lần thanh toán
      LoadLanThanhToan();
      return Promise.resolve();
    } else if (isThanhToan === 1) {
      return NhanVayApi.thanhToanNhanVay(
        NhanVayId,
        NgayThanhToan,
        NguoiNhan,
        TienThanhToan,
        PhiKhac,
        PhiKho,
        GhiChu
      ).then((response) => {
        if (response.data.Error === 0) {
          pushNotification(
            "Thanh toán thành công.",
            "success",
            "TOP_CENTER",
            1000
          );
        }
        dispatch(getListNhanVay(dataSearch));
        LoadLanThanhToan();
      });
    } else {
      return NhanVayApi.xoaThanhToanNhanVay(thuchiId).then((response) => {
        if (response.data.Error === 0) {
          pushNotification(
            "Xóa thanh toán thành công.",
            "success",
            "TOP_CENTER",
            1000
          );
        }
        dispatch(getListNhanVay(dataSearch));
        LoadLanThanhToan();
      });
    }
  };

  useEffect(() => {
    UpdateDataSearchLanDongLai({
      ...dataSearchLanDongLai,
      nhanvayId: props.nhanvayId,
      pageIndex: 1,
      pageSize: 5,
    });
    LoadLanThanhToan();
    TinhLaiDenNgay(props.nhanvayId, currentDate());
  }, []);

  // Thanh toán trên cùng
  const initThanhToanAll = {
    NhanVayId: props.nhanvayId,
    NgayThanhToan: currentDate(),
    NguoiNhan: props.NguoiNhan,
    TienThanhToan: 0,
    PhiKhac: 0,
    PhiKho: 0,
    GhiChu: "",
  };
  const [dataThanhToanAll, setThanhToanAll] = useState(initThanhToanAll);

  const TinhLaiDenNgay = (nhanvayId, date) => {
    NhanVayApi.laiDenNgay(nhanvayId, date).then((response) => {
      setThanhToanAll({
        ...dataThanhToanAll,
        NgayThanhToan: date,
        TienThanhToan: convertToNumber(response.data.TienThanhToan),
      });
    });
  };

  //Set Data khi Update trường dữ liệu
  const updateTextValue = (field) => (e) => {
    setThanhToanAll({
      ...dataThanhToanAll,
      [field]: e.target.value,
    });
    if (e.target.value === "") {
      setErrors({
        ...errors,
        nguoiNhan: "Tên người nhận không được để trống",
      });
      NguoiNhan.current.focus();
    } else {
      setErrors({
        ...errors,
        nguoiNhan: "",
      });
    }
  };
  const onChangeNumber = (field) => (evt) => {
    setThanhToanAll({
      ...dataThanhToanAll,
      [field]: convertToNumber(evt.target.value),
    });
    if (evt.target.value === "" || evt.target.value === 0) {
      setErrors2({
        ...errors2,
        TienThanhToan: "Nhập số tiền thanh toán",
      });
      TienThanhToan.current.focus();
    } else {
      setErrors2({
        ...errors2,
        TienThanhToan: "",
      });
    }
  };

  const onChangeDate = (field) => (evt) => {
    setThanhToanAll({
      ...dataThanhToanAll,
      [field]: formatDayMonth(evt),
    });
    TinhLaiDenNgay(props.nhanvayId, formatDayMonth(evt));
    if (evt === "null") {
      setErrors1({
        ...errors1,
        ngayThanhToan: "Nhập ngày thanh toán",
      });
    } else {
      setErrors1({
        ...errors1,
        ngayThanhToan: "",
      });
    }
  };

  const UpdateDataDongLai = (field) => (e) => {
    if (
      field === "PhiKhac" ||
      field === "PhiKho" ||
      field === "TienThanhToan"
    ) {
      setThanhToanAll({
        ...dataThanhToanAll,
        [field]: convertToNumber(e.target.value),
      });
    }
    if (field === "NgayThanhToan") {
      setThanhToanAll({
        ...dataThanhToanAll,
        [field]: formatDayMonth(e),
      });
      TinhLaiDenNgay(props.nhanvayId, formatDayMonth(e));
    } else {
      setThanhToanAll({
        ...dataThanhToanAll,
        [field]: e.target.value,
      });
    }
  };
  //Thông báo
  const initErrors = {
    nguoiNhan: "",
  };
  const [errors, setErrors] = useState(initErrors);
  const initErrors1 = {
    ngayThanhToan: "",
  };
  const [errors1, setErrors1] = useState(initErrors1);
  const initErrors2 = {
    TienThanhToan: "",
  };
  const [errors2, setErrors2] = useState(initErrors2);

  const NguoiNhan = React.createRef();
  const TienThanhToan = React.createRef();
  // Chặn bấm "Xác nhận" 2 lần liên tiếp trước khi request đóng lãi hoàn tất.
  const isSubmittingRef = React.useRef(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const onSubmit = () => {
    if (isSubmittingRef.current) return;
    if (dataThanhToanAll.NguoiNhan === "") {
      setErrors({
        ...errors,
        nguoiNhan: "Tên người nhận không được để trống",
      });
      NguoiNhan.current.focus();
      return;
    } else if (
      dataThanhToanAll.NgayThanhToan === "null" ||
      dataThanhToanAll.NgayThanhToan === null ||
      dataThanhToanAll.NgayThanhToan === ""
    ) {
      setErrors1({
        ...errors1,
        ngayThanhToan: "Nhập ngày thanh toán",
      });

      return;
    } else if (
      dataThanhToanAll.TienThanhToan === "" ||
      dataThanhToanAll.TienThanhToan === 0
    ) {
      setErrors2({
        ...errors2,
        TienThanhToan: "Nhập số tiền thanh toán",
      });
      TienThanhToan.current.focus();

      return;
    }
    isSubmittingRef.current = true;
    setIsSubmitting(true);
    NhanVayApi.thanhToanNhanVay(
      dataThanhToanAll.NhanVayId,
      dataThanhToanAll.NgayThanhToan,
      dataThanhToanAll.NguoiNhan,
      dataThanhToanAll.TienThanhToan,
      dataThanhToanAll.PhiKhac,
      dataThanhToanAll.PhiKho,
      dataThanhToanAll.GhiChu
    ).then((response) => {
      pushNotification("Đóng lãi thành công", "success", "TOP_CENTER", 1000);
      props.onHide();
      dispatch(getListNhanVay(dataSearch));
      // showAlert();
    }).finally(() => {
      isSubmittingRef.current = false;
      setIsSubmitting(false);
    });
  };
  return (
    <Modal
      {...props}
      size="modal-xl-new modal-xl-new"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <img src="/app-assets/images/icon-donglai.png" alt="" />
          </span>
          Trả lãi
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body className="form-donglai-mobile">
        <Tabs className="tabMorman">
          <Tab
            eventKey="chiTiet"
            title={<h4 className="tab-v2">Chi tiết đóng lãi </h4>}
          >
            <div class="detail-donglai">
              <div class="width-right-from order-lg-1 order-2 pt-1">
                <div class="disk-desktop show-mobile">
                  <div class="title-ls-donglai">
                    <h4>
                      Lịch sử đóng lãi{" "}
                      <i class="mdi mdi-chevron-double-down"></i>
                    </h4>
                    <a class="icon-print-mobile" href={() => false}>
                      <i class="mdi mdi-printer"></i>
                    </a>
                  </div>
                </div>
                <div class="table-from-new">
                  {dataLanDongLai && (
                    <TableKyLai
                      dataLanDongLai={dataLanDongLai}
                      UpdateThanhToan={UpdateThanhToan}
                      dataSearchLanDongLai={dataSearchLanDongLai}
                      PhanTrang={PhanTrang}
                      NguoiNhan={props.NguoiNhan}
                      nhanvayId={props.nhanvayId}
                      setHidePopupTraLai={props.onHide}
                      printThuChi={props.printThuChi}
                    />
                  )}

                  <div class="footer-page-new">
                    <div class="row">
                      <div class="col-xl-6 col-lg-12">
                        <BtnInTraLai nhanvayId={props.nhanvayId} />
                      </div>

                      <div class="col-xl-6 col-lg-12">
                        <div class="paniation-new d-flex just-end">
                          <nav aria-label="Page navigation">
                            <Pagination
                              activePage={dataSearchLanDongLai.pageIndex}
                              itemsCountPerPage={dataSearchLanDongLai.pageSize}
                              totalItemsCount={dataLanDongLai.TongBanGhi}
                              pageRangeDisplayed={5}
                              onChange={PhanTrang}
                              itemClass="page-item border-none"
                              linkClass="page-link border-none"
                              activeClass="active"
                            />
                          </nav>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="width-left-from order-lg-2 order-1 pt-1">
                <div class="title-donglai-mobile disk-desktop show-mobile">
                  <ul class="nav nav-tabs bg-tab">
                    <li
                      class={
                        "nav-item active" +
                        (isShowFormDongLai ? " collapsed-mobile" : "")
                      }
                      id="showdonglai"
                    >
                      <a
                        class="nav-link active"
                        id="base-tab1"
                        data-toggle="tab"
                        aria-controls="tab1"
                        href="#tab-thongtintt"
                        aria-expanded="true"
                        onClick={showFormInMobile}
                      >
                        <h4>
                          <span class="btn-icon-mobile">
                            Đóng lãi tuỳ biến theo ngày
                          </span>
                        </h4>
                      </a>
                    </li>
                  </ul>
                </div>

                <TraLai
                  updateTextValue={updateTextValue}
                  onChangeDate={onChangeDate}
                  onChangeNumber={onChangeNumber}
                  dataThanhToanAll={dataThanhToanAll}
                  onSubmit={onSubmit}
                  isSubmitting={isSubmitting}
                  NguoiNhan={NguoiNhan}
                  TienThanhToan={TienThanhToan}
                  errors={errors}
                  errors1={errors1}
                  errors2={errors2}
                  isShowFormDongLai={isShowFormDongLai}
                  setShowPopupTraLai={props.onHide}
                />
              </div>
            </div>
          </Tab>
          <Tab
            eventKey="ThongTinHopDong"
            title={<h4 className="tab-v2">Thông tin hợp đồng</h4>}
          >
            <ThongTinHopDong NhanVayId={props.nhanvayId} item={props.item} />
          </Tab>
        </Tabs>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-new-main btn-closenew"
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>
          Đóng
        </button>
      </Modal.Footer>
    </Modal>
  );
};
